import AppConfig from "../../app.config";
export default class ServerInfo {
    static async get() {
        const res = await fetch(`${AppConfig.REST.URL}/about/`);
        const json = await res.json();
        return json;
    }
}
